import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteBerekening, BokkzAlgDataService,
  OpbouwPGA
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService  } from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekeningen-persoonsgebonden-aftrek',
  templateUrl: './persoonsgebonden-aftrek.component.html',
  styleUrls: ['./persoonsgebonden-aftrek.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,

  ]
})
export class PersoonsgebondenAftrekBerekeningenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = <Aangifte>{};

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = <Aangifte>{};
    private partnerAangifte = <Aangifte>{};

    berekeningPGAFormGroup = this.fb.group<AangifteBerekening>({});
    berekeningPGA = <AangifteBerekening>{};

    constructor(  public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.berekeningPGAFormGroup = this.fb.group<AangifteBerekening>(({
            opbouwPGA: this.fb.group<OpbouwPGA>(({
                restantPgaVoorgaandeJaren: null as unknown as number,
                onderhoudsverplichtingen: null as unknown as number,
                specifiekeZorgkosten: null as unknown as number,
                weekenduitgaven: null as unknown as number,
                scholingsuitgaven: null as unknown as number,
                monumentenpanden: null as unknown as number,
                aftrekbareGiften: null as unknown as number,
                kwijtscheldingDurfkapitaal: null as unknown as number,
                aandeelPartnerPga: null as unknown as number
            } as OpbouwPGA))
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        this.dataService.aangifteBerekening.subscribe((value) => {
            this.berekeningPGA = value;
            this.berekeningPGAFormGroup.patchValue(this.berekeningPGA)
        });
    }

}
